<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog v-dialog-drag :title="title" append-to-body :visible.sync="showDialog" width="1200px"
      :destroy-on-close="true" :before-close="cancel">
      <el-form class="formDiv" label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="销售" prop="salesId">
          <el-select style="width: 300px;" :disabled="materialType === 'PROTECT_REAGENT'" v-model="form.salesId"
            placeholder="请选择销售" filterable>
            <el-option v-for="item in applicantOptions" :key="item.uuid" :label="item.name"
              :value="item.uuid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收件人名称" prop="recipientName">
          <el-autocomplete class="inline-input" v-model="form.recipientName" :fetch-suggestions="querySearch"
            :disabled="materialType === 'PROTECT_REAGENT'" placeholder="请输入收件人名称" @select="handleSelect"
            style="width: 300px;">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="收件人电话" prop="recipientPhone">
          <el-input style="width: 300px;" v-model="form.recipientPhone" auto-complete="off" placeholder="请输入收件人电话"
            :disabled="materialType === 'PROTECT_REAGENT'"></el-input>
        </el-form-item>
        <el-form-item label="收件人地址" prop="recipientAddress">
          <el-input style="width: 300px;" v-model="form.recipientAddress" auto-complete="off" placeholder="请输入收件人地址"
            :disabled="materialType === 'PROTECT_REAGENT'"></el-input>
        </el-form-item>
        <el-form-item label="送达时间(干冰)" prop="deliveryTime" v-if="flag">
          <el-input style="width: 300px;" v-model="form.deliveryTime" auto-complete="off" placeholder="请输入送达时间"
            :disabled="materialType === 'PROTECT_REAGENT'"></el-input>
        </el-form-item>
        <div style="width: 100%" v-for="(material, index) in form.materials" :key="'material' + index">
          <div style="display: flex;">
            <el-form-item :label="'物料名称'+ (form.materials.length>=2?(index+1):'')"
              :prop="'materials.'+index+'.materialLexiconId'"
              :rules="{required:true, message: '请选择物料名称', trigger: 'change'}">
              <el-select style="width: 300px;" v-model="material.materialLexiconId" placeholder="请选择物料名称" filterable
                @change="value => changeNumber(material, value)" :disabled="materialType === 'PROTECT_REAGENT'">
                <el-option v-for="item in filterOption(material.materialLexiconId)" :key="item.id"
                  :label="'物料：' + item.materialName + '，剩余：' + item.number" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="'申领数量'+ (form.materials.length>=2?(index+1):'')" :prop="'materials.'+index+'.number'"
              label-width="147px"
              :rules="[{ required: true, message: '请输入申领数量', trigger: 'change' },
                                  { validator: (rule, value, callback) => check(rule, value, material.remainingNumber,'', callback), trigger: 'change' },
                                  { validator: (rule, value, callback) => check(rule, value, material.limitQuantity,'', callback), trigger: 'change' }
                                  ]">
              <el-input-number :disabled="materialType === 'PROTECT_REAGENT'" style="width: 300px;"
                v-model="material.number"></el-input-number>
            </el-form-item>

            <div style="width:180px">
              <el-button type="danger" :disabled="materialType === 'PROTECT_REAGENT'" size="mini" icon="el-icon-delete"
                @click="handleDelete(material)">删除
              </el-button>
              <el-button v-if="index===form.materials.length-1" :disabled="materialType === 'PROTECT_REAGENT'"
                size="mini" type="success" class="title" @click="handleAdd">新增物料</el-button>
            </div>
          </div>
        </div>
        <el-form-item label="备注" prop="remark" style="width: 90%!important;">
          <el-input :autosize="{ minRows: 3}" type="textarea" maxlength="300" show-word-limit placeholder="请输入内容"
            v-model="form.remark" auto-complete="off" :disabled="materialType === 'PROTECT_REAGENT'"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" class="title" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {getPersonById, getPersonByType} from "@/api/dilivery/customer/person";
import {getDataInLocalStorage} from "@/utils/localStorage";
import {check, checkNum} from "@/utils/rules";
import {getMaterialType} from "@/api/dilivery/material/lexicon";
import {addRequest, editRequest} from "@/api/dilivery/material/request";
import {padDate} from "@/store/date";


export default {
  name: "AddEditRequest",
  props: ['showDialog', 'selectType', 'selectDetail'],
  data() {
    return {
      title: '',
      materialType:'',
      applicantOptions: [],
      LexiconOptions: [],
      form: {
        remark:'',
        materials: [],
        salesId: '',
        deliveryTime:'',
        recipientName: '',
        recipientPhone: '',
        recipientAddress: '',
        materialRequestDetailIds: []
      },
    }
  },
  computed: {
    selectValue() {
      return this.form.materials.map(item => item.materialLexiconId)
    },
    restaurants() {
      return this.applicantOptions
    },
    flag(){
      return this.LexiconOptions.filter(item => this.form.materials.map(itemA => itemA.materialLexiconId).includes(item.id)).map(item => item.materialType).includes('DRY_ICE')
    },
    rules() {
      return {
        salesId: [
          { required: true, message: '请选择销售', trigger: 'change' }
        ],
        recipientName: [
          { required: true, message: '请输入收件人名称', trigger: 'change' }
        ],
        recipientPhone: [
          { required: true, message: '请输入收件人电话', trigger: 'change' }
        ],
        recipientAddress: [
          { required: true, message: '请输入收件人地址', trigger: 'change' }
        ],
        deliveryTime: [
          { required: true, message: '请选择送达时间', trigger: 'change' },
          { validator: this.checkDate, trigger: 'change' }
        ]
      }
    },
    role(){
      return getDataInLocalStorage('role')
    },
    userData(){
      return JSON.parse(getDataInLocalStorage('user'))
    }
  },
  watch: {
    selectType: {
      handler(newVal) {
        if (newVal) {
          if (newVal === 'edit') {
            this.title = '编辑物料申领信息'
          } else {
            this.title = '添加物料申领信息'
          }
        }
      },
      immediate: true
    },
    selectDetail: {
      async handler(newVal) {
        if (!newVal || Object.keys(newVal).length === 0) return;

        // 使用解构赋值简化表单赋值
        const {
          id,
          salesId,
          remark,
          recipientName,
          recipientPhone,
          recipientAddress,
          deliveryTime,
          materialType,
          materialRequestDetailDTOS
        } = newVal;

        // 批量赋值表单字段
        Object.assign(this.form, {
          id,
          salesId,
          remark,
          recipientName,
          recipientPhone,
          recipientAddress,
          deliveryTime
        });

        this.materialType = materialType;
        await this.getLexiconOptions();

        // 获取所有相关的词库ID
        const materialLexiconIds = materialRequestDetailDTOS.map(item => item.materialLexiconId);

        // 获取匹配的词库选项
        const matchedLexicon = this.LexiconOptions.filter(item =>
          materialLexiconIds.includes(item.id)
        );

        // 创建匹配的词库ID集合，提高查找效率
        const matchedLexiconIds = new Set(matchedLexicon.map(item => item.id));

        // 处理材料列表
        this.$set(this.form, 'materials',
          materialRequestDetailDTOS
            .filter(item => matchedLexiconIds.has(item.materialLexiconId))
            .map(item => {
              const lexicon = this.LexiconOptions.find(l => l.id === item.materialLexiconId);
              return {
                id: item.id,
                materialLexiconId: item.materialLexiconId,
                number: item.number,
                remainingNumber: lexicon?.number || 0,
                limitQuantity: lexicon?.limitQuantity || ''
              };
            })
        );

        // 处理未匹配的材料ID
        this.form.materialRequestDetailIds = materialRequestDetailDTOS
          .filter(item => !matchedLexiconIds.has(item.materialLexiconId))
          .map(item => item.materialLexiconId);
      },
      immediate: true
    },
  },
  mounted() {
    this.getApplicantOption();

    if(this.form.materials.length<=0){
      this.handleAdd()
    }
    if (this.form.deliveryTime === '' && !(this.selectDetail && Object.keys(this.selectDetail).length > 0)){
      this.form.deliveryTime = this.getCurrentDate()
    }
  },
  created() {
    this.getLexiconOptions()
  },
  methods: {
    check,
    checkDate(rule, value, callback) {
      // 修改正则表达式以适应 yyyy-m-d 和 yyyy-mm-dd 格式，同时支持时间部分
      let datePattern = /^\d{4}-(?:0?[1-9]|1[0-2])-(?:0?[1-9]|[12]\d|3[01])?$/;

      if (datePattern.test(value)) {
        // 验证日期部分
        let [year, month, day] = value.split('-').map(Number);
        let dateOnly = new Date(year, month - 1, day);

        // 检查是否为有效日期
        if (isNaN(dateOnly.getTime()) || dateOnly.getFullYear() !== year || dateOnly.getMonth() + 1 !== month || dateOnly.getDate() !== day) {
          return callback(new Error('无效的日期格式'));
        }
        callback();
      } else {
        return callback(new Error('日期格式必须为YYYY-MM-DD'));
      }
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
      const day = date.getDate().toString().padStart(2, '0'); // 日期
      return `${year}-${month}-${day}`
    },
    querySearch(queryString, cb) {
      const results = queryString ? this.restaurants.filter(item => item.name.toLowerCase().includes(queryString.toLowerCase())) : this.restaurants;
      const modifiedItems = results.map(item => {
        if (item.name) {
          return {
            ...item,
            value: item.name,
            name: undefined
          };
        }
        return item;
      });
      cb(modifiedItems);
    },
    handleSelect(item) {
      this.form.recipientPhone = item.telephone
    },
    async changeNumber(material, value) {
      if (this.LexiconOptions.length === 0) {
        await this.getLexiconOptions()
      }
      const lexicon = this.LexiconOptions.find(item => item.id === value)
      this.$set(material, 'remainingNumber', lexicon ? lexicon.number : '')
      this.$set(material, 'limitQuantity', lexicon ? lexicon.limitQuantity : '')
    },
    filterOption(value) {
      if (value && value !== '') {
        return this.LexiconOptions.filter(item => !this.selectValue.includes(item.id) || item.id === value)
      }
      return this.LexiconOptions.filter(item => !this.selectValue.includes(item.id))
    },
    async getLexiconOptions() {
      try {
        const res = await getMaterialType({})
        if (res.code === 200) {
          if(this.selectType === 'edit' && this.selectDetail.materialType === 'PROTECT_REAGENT'){
            this.LexiconOptions = res.data.filter(item => item.materialType === 'PROTECT_REAGENT' && item.number !== 0 && item['materialStatus'])
          }else{
            this.LexiconOptions = res.data.filter(item => item.materialType !== 'PROTECT_REAGENT' && item.number !== 0 && item['materialStatus'])
          }
          if(this.selectType === 'edit'){
            if(this.materialType === 'DRY_ICE'){
              this.LexiconOptions = this.LexiconOptions.filter(item => item.materialType === 'DRY_ICE')
            }else{
              this.LexiconOptions = this.LexiconOptions.filter(item => item.materialType !== 'DRY_ICE')
            }
          }
        }
      } catch (error) { console.log(error); }
    },
    checkNum,
    handleDelete(item) {
      const index = this.form.materials.indexOf(item)
      if (index !== -1) {
        if (this.form.materials[index].id) {
          this.form.materialRequestDetailIds.push(this.form.materials[index].id)
        }
        this.form.materials.splice(index, 1)
      }
      if(this.form.materials.length===0){
        this.handleAdd()
      }
    },
    handleAdd() {
      let material = {
        number: 1,
        materialLexiconId: '',
        remainingNumber: '',
        limitQuantity: '',
      }
      this.form.materials.push(material)
    },
    checkUser() {
      if (this.applicantOptions.some(item => item.uuid === this.userData['personUuids'][0])) {
        if (this.form.salesId === '') {
          this.form.salesId = this.userData['personUuids'][0]
        }
      }
    },
    getApplicantOption() {
      try {
        if (['ADMIN', 'MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'].includes(this.role)) {
          getPersonByType('SALES', {}).then(res => {
            if (res.code === 200) {
              this.applicantOptions = res.data;
            }
          }).catch(err => {})
        } else {
          getPersonById(this.userData['personUuids'][0], {}).then(res => {
            if (res.code === 200) {
              this.applicantOptions = res.data;
              this.checkUser();
            }
          }).catch(err => {})
        }
      } catch (error) { console.log(error); }
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    handle() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.materials.length === 0) {
            this.$messageUi.error('请添加至少一条物料申领信息')
            return
          }
          this.form.deliveryTime = padDate(this.form.deliveryTime,'date')
          if (this.selectType === 'add') {
            addRequest(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit', 'confirm')
                this.$messageUi.success('提交成功')
              }
            }).catch(err => {
            })
          } else {
            editRequest(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit', 'confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
            })
          }
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.el-dialog-div {
  @include thin-scrollbar(8px, #888);
  max-height: 60vh;
  /* 你还可以在这个类里写其他样式 */
  background: #fff;
}

.formDiv {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.formDiv :deep(.el-form-item){
  width: 45%;
  align-items: center;
}
</style>